import Section from "@/components/custom/section";
import { Marquee } from "@/components/magicui/marquee";


type TextMarqueeSectionProps = {
  text: string | React.ReactNode;
  text2?: string | React.ReactNode;
  noAnimation?: boolean;
}

export default function TextMarqueeSection({ text, text2, noAnimation = false }: TextMarqueeSectionProps) {
  return (
    <Section noPadding={!noAnimation} className="pt-18">
      {
        !noAnimation && (
          <div className="lg:hidden block">
            <Marquee className="[--duration:10s]">
              <h1
                className="text-6xl font-black md:text-7xl xl:text-8xl uppercase text-center"
                >
                {text}
              </h1>      
              <h1
                className="text-6xl font-black md:text-7xl xl:text-8xl uppercase text-center"
                >
                {text2}
              </h1>
            </Marquee>
          </div>
        )
      }

      <div className={
        noAnimation 
        ? "block"
        : "hidden lg:block"
      }> 
        <h1
          className="text-5xl text-secondary  md:text-7xl font-black xl:text-8xl uppercase text-center"
          >
          {text}
        </h1>      
        <h1
          className="text-5xl text-secondary md:text-7xl font-black xl:text-8xl uppercase text-center"
          >
          {text2}
        </h1>
      </div>
    </Section>
  );
}

